import * as React from 'react'
import { ReactNode } from 'react'

import { FullLogo } from '../features/icons/FullLogo'

type Props = {
  children: ReactNode
}

export const AuthLayout = ({ children }: Props) => {
  return (
    <div className="tw-flex !tw-h-screen tw-justify-start tw-overflow-hidden tw-bg-white tw-font-primary tw-text-content-base">
      <div className="tw-center-grid tw-relative tw-overflow-y-auto tw-overflow-x-hidden">
        <div className="tw-first-block-on-grid tw-col-span-5-on-grid tw-h-full tw-w-full tw-items-center tw-justify-start tw-pb-8 tw-pt-8">
          <div className="tw-m-auto tw-mb-36 tw-mt-10 tw-max-w-92">
            <FullLogo className="tw-h-8" />
          </div>
          <div className="tw-m-auto tw-flex tw-w-full tw-max-w-92 tw-flex-col tw-justify-start tw-gap-8">
            <div className="tw-flex tw-flex-wrap tw-flex-col tw-gap-1.5">{children}</div>
          </div>
        </div>
      </div>

      <div className="tw-absolute tw-right-0 tw-hidden tw-h-full tw-items-center tw-justify-end tw-pb-4 tw-pr-4 tw-pt-4 lg:tw-left-[490px] lg:!tw-flex xl:tw-left-[634px] 2xl:tw-left-[846px]">
        <img
          loading="lazy"
          src="/assets/img/et/et-bg-1.jpg"
          alt="truck on the road"
          className="tw-h-full tw-w-full tw-rounded-3xl tw-border-2 tw-border-solid tw-border-content-base tw-border-opacity-20 tw-object-cover"
        />
      </div>
    </div>
  )
}
